module.exports = __webpack_public_path__ + "img/img-ac18bb5a.17ccfa3b.png";